module.exports = __webpack_public_path__ + "static/work_icon_dev_web-0dc24a8760082c05e9678f75e7bb3ba1.png";